import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {Button} from 'primereact/button';
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {InputNumber} from "primereact/inputnumber";
import {Checkbox} from "primereact/checkbox";
import {withTranslation} from 'react-i18next';
import {classNames} from 'primereact/utils';
import {addLocale} from "primereact/api";
import moment from "moment";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";

const hasPriceValue = (value) => value !== undefined && value !== null && value !== '';
const normalizePrice = (value) => hasPriceValue(value) ? String(value).replace(/\.00$/, '') : null;

const _FM_PriceUnitFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {date, resource, action, id} = useParams();
  const [formData, setFormData] = useState({
    price_category: Number(window.App.urlVars().categoryId),
  });
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [unit, setUnit] = useState([]);
  const [unitName, setUnitName] = useState('');
  const [priceCategories, setPriceCategories] = useState([]);
  const [berth, setBerth] = useState([]);
  const [loading, setLoading] = useState(false);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  const validate = (data) => {
    let errors = {};
    return errors;
  };

  const onSubmit = (data, form) => {
    let _unit = null
    if (data.residential_unit) {
      _unit = {residential_unit: data.residential_unit.id || data.residential_unit}
    }
    if (data.berth) {
      _unit = {berth: data.berth.id || data.berth}
    }
    if (data.category) {
      _unit = {category: data.category.id || data.category}
    }
    let _price = {}
    if ([data.unit_price, data.adult_price, data.child_price].some(hasPriceValue)) {
      _price = {
        unit_price: normalizePrice(data.unit_price),
        adult_price: normalizePrice(data.adult_price),
        child_price: normalizePrice(data.child_price),
      }
    }
    if (hasPriceValue(data.berth_price)) {
      _price = {berth_price: normalizePrice(data.berth_price)}
    }

    if (formData.days_of_week || formData.end_date) {
      let _data = {
        start_date: data.start_date,
        end_date: data.end_date,
        days_of_week: data.days_of_week,
        ..._price,
        ..._unit,
        price_category: data.price_category || data.price_category.id,
      }
      setLoading(true)
      apiCall('post', 'price/bulk', _data)
        .then(response => {
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderPriceList: Math.random(),
            selectedPriceId: response.data.data.id,
          })
          navigate(-1)
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      let _number_of_days = 0
      if (data.end_date) {
        _number_of_days = moment(data.end_date).diff(moment(data.start_date), 'days')
      }
      let _data = {
        date: data.start_date,
        number_of_days: _number_of_days,
        ..._price,
        ..._unit,
        price_category: data.price_category || data.price_category.id,
      }
      if (id) {
        delete _data.number_of_days;
        delete _data.days_of_week;
        setLoading(true)
        apiCall('patch', 'price/' + id, _data)
          .then(response => {
            setLoading(false)
            window.App.toastShow('success', t('success'), response.data.message)
            window.App.setState({
              rerenderPriceList: Math.random(),
              selectedPriceId: response.data.data.id,
            })
            navigate(-1)
          })
          .catch(error => {
            setLoading(false)
            window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          })
      } else {
        setLoading(true)
        apiCall('post', 'price', _data)
          .then(response => {
            setLoading(false)
            window.App.toastShow('success', t('success'), response.data.message)
            window.App.setState({
              rerenderPriceList: Math.random(),
              selectedPriceId: response.data.data.id,
            })
            navigate(-1)
          })
          .catch(error => {
            setLoading(false)
            window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          })
      }
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  useEffect(() => {
    if (formData.residential_unit) {
      apiCall('get', 'residential-unit')
        .then(response => {
          setUnit(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
      apiCall('get', 'berth' + '?search[residential_unit][operator]=%3D&search[residential_unit][value]=' + formData.residential_unit)
        .then(response => {
          setBerth(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData.residential_unit])

  useEffect(() => {
    apiCall('get', 'residential-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + localStorage.getItem('selectedAccommodation'))
      .then(response => {
        setCategories(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (id) {
      apiCall('get', 'price/' + id)
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + localStorage.getItem('selectedAccommodation'))
      .then(response => {
        setPriceCategories(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [id]);
  useEffect(() => {
    setFormData({
      ...formData,
      start_date: moment.utc(formData.date).local().format(t('YYYY-MM-DD')),
    })
  }, [formData.date]);

  useEffect(() => {
    if (resource && resource.includes('U-') && !formData.id) {
      if (unit && unit[0]) {
        let _unit = unit.filter(item => item.id === Number(resource.split('-')[1]))[0]
        setUnitName(_unit.name)
        setCategoryName(_unit?.residential_category?.name)
      }
      setFormData({
        ...formData,
        residential_unit: Number(resource.split('-')[1]),
        start_date: date,
      })
    }
  }, [unit])

  useEffect(() => {
    if (formData.price_category && priceCategories && priceCategories[0]) {
      let _priceCategory = priceCategories.filter(item => item.id === formData.price_category)[0]
      setFormData((prevState) => ({
        ...prevState,
        include_tourist_tax: _priceCategory?.include_tourist_tax,
      }));
    }
  }, [priceCategories, formData.price_category])

  useEffect(() => {
    if (formData.price_category && formData.price_category.id) {
      setFormData((prevState) => ({
        ...prevState,
        price_category: formData.price_category.id,
      }));
    }
  }, [formData.price_category])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <h2 className={"p-mb-0"}>
          {formData.id ? (
            <>{formData?.residential_unit?.name || formData?.berth?.name}</>
          ) : (
            <>{unitName}</>
          )}
          {formData.id &&
            <span style={{float: 'right', fontSize: '1rem'}} className={"p-text-normal p-mt-1"}>
              #{formData.id}
            </span>
          }
        </h2>
        <div className={"p-grid"} style={{clear: 'both'}}>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('category')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {formData.id ? (
                <>{formData?.residential_unit?.residential_category?.name || formData?.berth?.residential_category?.name}</>
              ) : (
                <>{categoryName}</>
              )}
            </p>
          </div>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('pricecategory')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {(() => {
                let _priceCategory = priceCategories.filter(item => item.id === (formData.price_category.id ?? formData.price_category))[0]
                return _priceCategory?.name
              })()}
            </p>
          </div>
          {formData.created_at_snapshot &&
            <div className={"p-col"}>
              <small className={"p-text-uppercase"}>
                {t('created_at')}
              </small>
              <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
              </p>
            </div>
          }
          {formData.updated_at_snapshot &&
            <div className={"p-col"}>
              <small className={"p-text-uppercase"}>
                {t('updated_at')}
              </small>
              <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
              </p>
            </div>
          }
          <div className={"p-col p-col-align-center p-text-right"}style={{maxWidth: '60px'}}>
            <Button type="button"
                    icon={"pi pi-times"}
                    onClick={() => {
                      navigate(-1)
                    }}
                    className="p-button-secondary close p-ml-2">
            </Button>
          </div>
        </div>
        <Panel className={"p-mt-3"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center"}>
              <h2 className={"p-m-0 p-d-inline"}>
                {t('price_form')}
              </h2>
            </div>
            <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
              {formData.id &&
                <Button type="button" aria-label={t('delete')}
                        loading={loading}
                        onClick={() => {
                          apiCall('delete', 'price/' + id)
                            .then(response => {
                              window.App.setState({
                                rerenderPriceList: Math.random(),
                              })
                              navigate(-1)
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                            })
                        }}
                        className="p-button-danger p-ml-2">
                    <span>
                      <i className={"pi pi-trash"}></i>
                    </span>
                </Button>
              }
              <Button type="submit" aria-label={t('save_and_close')}
                      loading={loading}
                      onClick={() => {
                        props = {...props, closeForm: true}
                      }}
                      className="p-button-success p-ml-2">
                    <span>
                      <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                    </span>
              </Button>
            </div>
          </div>
          {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
          <HelpComponent type={"edit_box"}/>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-3 p-xl-3"}>
              {resource && resource.includes('U-') &&
                <Field name="unit_price" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <HelpComponent type={"field"} field={"unit_price"}/>
                    <label htmlFor="unit_price"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('unit_price')}</label>
                    <span className="p-d-block">
                    <InputText id="unit_price" {...input}
                               keyfilter={"num"}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   unit_price: e.target.value
                                 })
                               }}
                               value={formData.unit_price}
                               className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              }
              {resource && resource.includes('B-') &&
                <Field name="berth_price" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <HelpComponent type={"field"} field={"berth_price"}/>
                    <label htmlFor="berth_price"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('berth_price')}</label>
                    <span className="p-d-block">
                      <InputText id="berth_price" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     berth_price: e.target.value
                                   })
                                 }}
                                 value={formData.berth_price}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              }
              {resource && resource.includes('C-') &&
                <Field name="category_price" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <HelpComponent type={"field"} field={"berth_price"}/>
                    <label htmlFor="category_price"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('category_price')}</label>
                    <span className="p-d-block">
                    <InputText id="category_price" {...input}
                               keyfilter={"num"}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   category_price: e.target.value
                                 })
                               }}
                               value={formData.category_price}
                               className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              }
            </div>
            {resource && !resource.includes('B-') &&
              <>
                <div className={"p-col-12 p-lg-3 p-xl-3"}>
                  <Field name="adult_price" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"adult_price"}/>
                      <label htmlFor="adult_price"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('adult_price')}</label>
                      <span className="p-d-block">
                    <InputText id="adult_price" {...input}
                               keyfilter={"num"}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   adult_price: e.target.value
                                 })
                               }}
                               value={formData.adult_price}
                               className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3 p-xl-3"}>
                  <Field name="child_price" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"child_price"}/>
                      <label htmlFor="child_price"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('child_price')}</label>
                      <span className="p-d-block">
                        <InputText id="child_price" {...input}
                                   keyfilter={"num"}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       child_price: e.target.value
                                     })
                                   }}
                                   value={formData.child_price}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                        </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </>
            }
            <div className={"p-col-12 p-lg-3 p-xl-3"}>
              <Field name="currency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"currency"}/>
                  <label htmlFor="currency"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('currency')}</label>
                  <span className="p-d-block fake-input">
                    {window.App.urlVars().categoryId ? (
                      <>
                        {(() => {
                          let _priceCategory = priceCategories.filter(item => item.id === Number(window.App.urlVars().categoryId))[0]
                          return _priceCategory?.accommodation?.currency_code || ''
                        })()}
                      </>
                    ) : (
                      <>
                        {(() => {
                          let _priceCategory = priceCategories.filter(item => item.id === (formData.price_category.id ?? formData.price_category))[0]
                          return _priceCategory?.accommodation?.currency_code || ''
                        })()}
                      </>
                    )}
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4 p-xl-4"}>
              <Field name="price_category" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"price_category"}/>
                  <label htmlFor="price_category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('pricecategory')}</label>
                  <span className="p-d-block">
                      <Dropdown  options={priceCategories}
                                filter
                                disabled
                                optionLabel="name"
                                optionValue="id"
                                id={"price_category"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  let _priceCategory = priceCategories.filter(item => item.id === e.value)[0]
                                  setFormData({
                                    ...formData,
                                    price_category: e.value,
                                    include_tourist_tax: _priceCategory?.include_tourist_tax,
                                  })
                                }}
                                value={formData.price_category?.id || formData.price_category}
                      />
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4 p-xl-4"}>
              <div className="p-field p-fluid">
                <HelpComponent type={"field"} field={"include_tourist_tax"}/>
                <label htmlFor="include_tourist_tax">{t('include_tourist_tax')}</label>
                <span className="p-d-block fake-input">
                  &nbsp;
                  {formData.include_tourist_tax === true &&
                    <>
                      {t('yes')}
                    </>
                  }
                  {formData.include_tourist_tax === false &&
                    <>
                      {t('no')}
                    </>
                  }
                  </span>
              </div>
            </div>
          </div>
          <div className={"p-grid"}>
            <div className={"p-col p-col-align-center"}>
              <h3 className={"p-m-0 p-d-inline"}>
                {t('timing')}
              </h3>
            </div>
            <div className={"p-col p-text-right p-col-align-center"}>

            </div>
          </div>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"} style={{minWidth: '160px'}}>
              <Field name="date" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <HelpComponent type={"field"} field={"date"}/>
                  <label htmlFor="date"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('date_from')}</label>
                  <span className="">
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"date"}
                                 mask={t('9999-99-99')}
                                 value={formData.start_date}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       start_date: e.value
                                     })
                                   }
                                 }}
                      />
                      <Calendar value={formData.start_date ? moment(formData.start_date, 'YYYY-MM-DD').toDate() : null}
                                locale="default"
                                dateFormat={t('YY-MM-DD')}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    start_date: moment.utc(e.value).local().format(t('YYYY-MM-DD'))
                                  })
                                }}/>
                    </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6"} style={{minWidth: '160px'}}>
              <div className="p-field p-fluid">
                <HelpComponent type={"field"} field={"date_to"}/>
                <label htmlFor="date_to">{t('date_to')}</label>
                <span className="">
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id={"end_date"}
                                 disabled={!formData.start_date}
                                 mask={t('9999-99-99')}
                                 value={formData.end_date}
                                 onChange={(e) => {
                                   if (e.value.indexOf("_") === -1) {
                                     if (e.value === '') {
                                       e.value = null
                                     }
                                     setFormData({
                                       ...formData,
                                       end_date: e.value
                                     })
                                     if (!formData.days_of_week || formData.days_of_week.length === 0) {
                                       setFormData({
                                         ...formData,
                                         days_of_week: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
                                       })
                                     }
                                   }
                                 }}
                      />
                      <Calendar value={formData.end_date ? moment(formData.end_date, 'YYYY-MM-DD').toDate() : null}
                                disabled={!formData.start_date}
                                locale="default"
                                dateFormat={t('YY-MM-DD')}
                                showIcon
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    end_date: moment.utc(e.value).local().format(t('YYYY-MM-DD'))
                                  })
                                  if (!formData.days_of_week || formData.days_of_week.length === 0) {
                                    setFormData({
                                      ...formData,
                                      days_of_week: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
                                      end_date: moment.utc(e.value).local().format(t('YYYY-MM-DD'))
                                    })
                                  }
                                }}/>
                    </div>
                    </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <table className={"w-100"}>
                <tr>
                  <th>{t('mon')}</th>
                  <th>{t('tue')}</th>
                  <th>{t('wed')}</th>
                  <th>{t('thu')}</th>
                  <th>{t('fri')}</th>
                  <th>{t('sat')}</th>
                  <th>{t('sun')}</th>
                </tr>
                <tr>
                  <td className={"p-text-center"}>
                    <Checkbox onChange={(e) => {
                      const days = formData.days_of_week || [];
                      const selectedDay = 'monday';
                      const updatedDays = e.checked
                        ? [...days, selectedDay]
                        : days.filter(day => day !== selectedDay);
                      setFormData({
                        ...formData,
                        days_of_week: updatedDays,
                      });
                    }}
                              checked={formData.days_of_week && formData.days_of_week.toString().includes('monday')}>
                    </Checkbox>
                  </td>
                  <td className={"p-text-center"}>
                    <Checkbox onChange={(e) => {
                      const days = formData.days_of_week || [];
                      const selectedDay = 'tuesday';
                      const updatedDays = e.checked
                        ? [...days, selectedDay]
                        : days.filter(day => day !== selectedDay);
                      setFormData({
                        ...formData,
                        days_of_week: updatedDays,
                      });
                    }}
                              checked={formData.days_of_week && formData.days_of_week.toString().includes('tuesday')}>
                    </Checkbox>
                  </td>
                  <td className={"p-text-center"}>
                    <Checkbox onChange={(e) => {
                      const days = formData.days_of_week || [];
                      const selectedDay = 'wednesday';
                      const updatedDays = e.checked
                        ? [...days, selectedDay]
                        : days.filter(day => day !== selectedDay);
                      setFormData({
                        ...formData,
                        days_of_week: updatedDays,
                      });
                    }}
                              checked={formData.days_of_week && formData.days_of_week.toString().includes('wednesday')}>
                    </Checkbox>
                  </td>
                  <td className={"p-text-center"}>
                    <Checkbox onChange={(e) => {
                      const days = formData.days_of_week || [];
                      const selectedDay = 'thursday';
                      const updatedDays = e.checked
                        ? [...days, selectedDay]
                        : days.filter(day => day !== selectedDay);
                      setFormData({
                        ...formData,
                        days_of_week: updatedDays,
                      });
                    }}
                              checked={formData.days_of_week && formData.days_of_week.toString().includes('thursday')}>
                    </Checkbox>
                  </td>
                  <td className={"p-text-center"}>
                    <Checkbox onChange={(e) => {
                      const days = formData.days_of_week || [];
                      const selectedDay = 'friday';
                      const updatedDays = e.checked
                        ? [...days, selectedDay]
                        : days.filter(day => day !== selectedDay);
                      setFormData({
                        ...formData,
                        days_of_week: updatedDays,
                      });
                    }}
                              checked={formData.days_of_week && formData.days_of_week.toString().includes('friday')}>
                    </Checkbox>
                  </td>
                  <td className={"p-text-center"}>
                    <Checkbox onChange={(e) => {
                      const days = formData.days_of_week || [];
                      const selectedDay = 'saturday';
                      const updatedDays = e.checked
                        ? [...days, selectedDay]
                        : days.filter(day => day !== selectedDay);
                      setFormData({
                        ...formData,
                        days_of_week: updatedDays,
                      });
                    }}
                              checked={formData.days_of_week && formData.days_of_week.toString().includes('saturday')}>
                    </Checkbox>
                  </td>
                  <td className={"p-text-center"}>
                    <Checkbox onChange={(e) => {
                      const days = formData.days_of_week || [];
                      const selectedDay = 'sunday';
                      const updatedDays = e.checked
                        ? [...days, selectedDay]
                        : days.filter(day => day !== selectedDay);
                      setFormData({
                        ...formData,
                        days_of_week: updatedDays,
                      });
                    }}
                              checked={formData.days_of_week && formData.days_of_week.toString().includes('sunday')}>
                    </Checkbox>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </Panel>
      </form>
    )}/>
  )
}
export default withTranslation('common')(_FM_PriceUnitFormComponent);
